// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --color-ehadj-primary: 0 109 49;
}

.roaster-coffee {
    background-color: #efefef;
}

/* Icons */

span.icon.gray {
    background-color: #d1d1d1;
}

/* Table */

table.datatable td {
    vertical-align: middle;
}

/* Authentication */

nav.appnav .app-logo img {
    max-width: 103px;
}

.auth-form-container {
    margin: 100px auto;
}

.auth-form-container .button {
    width: auto;
    max-width: none;
    margin: 0;
}

.auth-form-container .button.full-width {
    width: 100%;
}

.prefixed-input {
    padding-left: 60px;
}

.stats-container {
    align-items: stretch;
}

nav.appnav .appnav-section.header {
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #d1d1d1;
}

/* color override */
nav.appnav li .menu-item.active,
nav.appnav li .menu-item:active {
    background-color: rgba(var(--color-ehadj-primary) / 20%);
}

nav.appnav li .menu-item.active::after,
figure.loader span.loading-level {
    background-color: rgba(var(--color-ehadj-primary));
}

nav.appnav li .menu-item:hover {
    background-color: rgba(var(--color-ehadj-primary) / 15%);
}

figure.loader {
    background-color: rgba(var(--color-ehadj-primary) / 40%);
}

article.card-stat figure.progress.circular span.progress-level {
    background: conic-gradient(
        rgba(var(--color-ehadj-primary)) calc(var(--percent) * 3.6deg),
        rgba(var(--color-smoke)) 0deg
    );
}

/* add style for sidebar icons */
nav.appnav span.icon i,
nav.appnav span.icon img,
nav.appnav span.icon svg {
    height: 20px;
}

/* small gray icons */
span.icon.small.gray i {
    font-size: 10px;
}

/* change checkbox background color */
form input[type='checkbox']:checked ~ span.input-checkbox {
    background-color: rgba(var(--color-ehadj-primary) / 80%);
}

/* set as minimum height for stats cards */
article.card-stat {
    min-height: 90px;
}

@media only screen and (max-width: 1023px) {
    section.appnav-opener-mobile {
        background: #efefef;
    }

    body section.appnav-opener-mobile .app-logo {
        height: 80%;
    }

    aside.appnav-container {
        background: #fff;
    }

    article.card-stat .fa-regular.fa-circle-info,
    section.table-section .table-container .fa-regular.fa-circle-info {
        display: none;
    }

    table.datatable td.selector,
    table.datatable th.selector,
    section.table-form .table-actions .card-dropdown-container,
    section.table-form .table-meta .tags-container {
        display: block;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/main.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,UAAU;;AAEV;IACI,yBAAyB;AAC7B;;AAEA,UAAU;;AAEV;IACI,sBAAsB;AAC1B;;AAEA,mBAAmB;;AAEnB;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gCAAgC;AACpC;;AAEA,mBAAmB;AACnB;;IAEI,wDAAwD;AAC5D;;AAEA;;IAEI,kDAAkD;AACtD;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI;;;KAGC;AACL;;AAEA,gCAAgC;AAChC;;;IAGI,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,eAAe;AACnB;;AAEA,qCAAqC;AACrC;IACI,wDAAwD;AAC5D;;AAEA,0CAA0C;AAC1C;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;;;QAII,cAAc;IAClB;AACJ","sourcesContent":[":root {\n    --color-ehadj-primary: 0 109 49;\n}\n\n.roaster-coffee {\n    background-color: #efefef;\n}\n\n/* Icons */\n\nspan.icon.gray {\n    background-color: #d1d1d1;\n}\n\n/* Table */\n\ntable.datatable td {\n    vertical-align: middle;\n}\n\n/* Authentication */\n\nnav.appnav .app-logo img {\n    max-width: 103px;\n}\n\n.auth-form-container {\n    margin: 100px auto;\n}\n\n.auth-form-container .button {\n    width: auto;\n    max-width: none;\n    margin: 0;\n}\n\n.auth-form-container .button.full-width {\n    width: 100%;\n}\n\n.prefixed-input {\n    padding-left: 60px;\n}\n\n.stats-container {\n    align-items: stretch;\n}\n\nnav.appnav .appnav-section.header {\n    align-items: center;\n    padding: 8px 0;\n    border-bottom: 1px solid #d1d1d1;\n}\n\n/* color override */\nnav.appnav li .menu-item.active,\nnav.appnav li .menu-item:active {\n    background-color: rgba(var(--color-ehadj-primary) / 20%);\n}\n\nnav.appnav li .menu-item.active::after,\nfigure.loader span.loading-level {\n    background-color: rgba(var(--color-ehadj-primary));\n}\n\nnav.appnav li .menu-item:hover {\n    background-color: rgba(var(--color-ehadj-primary) / 15%);\n}\n\nfigure.loader {\n    background-color: rgba(var(--color-ehadj-primary) / 40%);\n}\n\narticle.card-stat figure.progress.circular span.progress-level {\n    background: conic-gradient(\n        rgba(var(--color-ehadj-primary)) calc(var(--percent) * 3.6deg),\n        rgba(var(--color-smoke)) 0deg\n    );\n}\n\n/* add style for sidebar icons */\nnav.appnav span.icon i,\nnav.appnav span.icon img,\nnav.appnav span.icon svg {\n    height: 20px;\n}\n\n/* small gray icons */\nspan.icon.small.gray i {\n    font-size: 10px;\n}\n\n/* change checkbox background color */\nform input[type='checkbox']:checked ~ span.input-checkbox {\n    background-color: rgba(var(--color-ehadj-primary) / 80%);\n}\n\n/* set as minimum height for stats cards */\narticle.card-stat {\n    min-height: 90px;\n}\n\n@media only screen and (max-width: 1023px) {\n    section.appnav-opener-mobile {\n        background: #efefef;\n    }\n\n    body section.appnav-opener-mobile .app-logo {\n        height: 80%;\n    }\n\n    aside.appnav-container {\n        background: #fff;\n    }\n\n    article.card-stat .fa-regular.fa-circle-info,\n    section.table-section .table-container .fa-regular.fa-circle-info {\n        display: none;\n    }\n\n    table.datatable td.selector,\n    table.datatable th.selector,\n    section.table-form .table-actions .card-dropdown-container,\n    section.table-form .table-meta .tags-container {\n        display: block;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
